import {
  Component,
  OnDestroy,
  OnInit,
} from "@angular/core";
import * as _lodash from "lodash";
import * as _underscore from "underscore";
import { CommonService } from "app/reusable/common.service";
import { environment } from "environments/environment";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { SettingService } from "app/_services/setting.service";
import { CedNotificationService } from "ced-ng-library";

@Component({
  selector: 'app-countries-list',
  templateUrl: './countries-list.component.html',
  styleUrls: ['./countries-list.component.scss']
})
export class CountriesListComponent implements OnInit, OnDestroy {
  destroySubject$: Subject<void> = new Subject();
  private _subject$: Subject<boolean> = new Subject();
  dataSource = [];
  data = [];
  public isloading: boolean = true;
  public serverUrlSlot3 : string = environment.Services.AlphaURLSlot3;

  constructor(private settingService : SettingService,
    private commonService: CommonService,
    private cedNotificationService: CedNotificationService
  ) { }

  ngOnInit() {
    this.getCountries();
    this.getCountriesSpecificInformationLinks();
  }

  getCountriesSpecificInformationLinks(){
    this.settingService
      .getAll(true)
      .pipe(takeUntil(this._subject$))
      .subscribe((data) => {
        this.data = data;
      },
      (error) => {
        this.cedNotificationService.warning("NOTIFICATIONS.ALL_COUNTRIES");
      });
  }

  getCountries() {
    let getCountriesUrl: string = `Country/Get`;
    this.commonService.getData(getCountriesUrl, this.serverUrlSlot3,true)
      .pipe(takeUntil(this._subject$))
      .subscribe((data: any) => {
        this.dataSource = data;
      },
      (error) => {
        this.cedNotificationService.warning("NOTIFICATIONS.ALL_COUNTRIES");
      });
      this.isloading = false;
  }

  public getSpecificInformationLink(id) {
    if (id != null) {
      let item = this.data.find(e=>e.setKey == id);
      if(item != null && item != undefined){
        if(item.setValue != "") {
          return this.data.find(e=>e.setKey == id).setValue;
        }
      }
    }
  }

  ngOnDestroy(): void {
    this._subject$.unsubscribe();
  }
}